module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    ref: "workflow",
    attrs: {
      "title": "Master Workflow",
      "title-heading": "h2",
      "icon": "fa fa-cogs",
      "tableRef": "workflowtable",
      "url": "/workflow",
      "fields": _vm.listFields,
      "sort-field": "id",
      "show-search": false,
      "hide-org-badge": "",
      "detail-component": "workflow-row",
      "addAction": _vm.addActionComp
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function(props) {
        return [(props.rowData.name && props.rowData.type) ? _c('span', [_vm._v(_vm._s(props.rowData.type) + ": "), _c('b', {
          staticClass: "text-primary"
        }, [_vm._v(_vm._s(props.rowData.name))])]) : _c('span', {
          staticClass: "text-primary"
        }, [_vm._v(_vm._s(props.rowData.name))])]
      }
    }, {
      key: "view",
      fn: function(props) {
        return [_c('center', [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "mini",
            "round": "",
            "plain": "",
            "icon": "fa fa-angle-double-down"
          },
          on: {
            "click": function($event) {
              return _vm.showDetail(props.rowData.id)
            }
          }
        }, [_vm._v("\n           Show\n        ")])], 1)]
      }
    }, {
      key: "deleteRow",
      fn: function(props) {
        return [(_vm.isManager('project|maintenance')) ? _c('el-button', {
          staticClass: "pull-right",
          attrs: {
            "size": "small",
            "type": "danger",
            "circle": "",
            "disabled": props.rowData.activeSites > 0
          },
          on: {
            "click": function($event) {
              return _vm.onDelete(props.rowData)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        })]) : _vm._e()]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74967dac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workflow/Workflow.vue
// module id = 1560
// module chunks = 0